import { UserComment } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { extractUserAlias } from '../../api/UtilsApi';
import UserTitle from '../../model/UserTitle';
import { userTitleDisplayNames } from '../utils/DisplayNames';
import { Box } from '@amzn/awsui-components-core';

interface Props {
  userComment: UserComment;
  userTitle?: UserTitle;
}

const CommentHeaderInfo = (props: Props) => {
  const { userComment, userTitle } = props;
  const { userProfile, createdAt } = userComment;
  const { userId, name } = userProfile;
  const userAlias = userId.startsWith('AmazonCorporate') ? extractUserAlias(userId) : null;
  return (
    <div>
      <div>{userAlias ? `${name} (${userAlias})` : `${name}`}</div>
      <Box color="text-status-inactive" fontSize="body-s">
        {/* @ts-expect-error TS2345 - strict migration */}
        {userTitleDisplayNames.get(userTitle)}
      </Box>
      <Box color="text-status-inactive" fontSize="body-s">
        {createdAt.toRelative()}
      </Box>
    </div>
  );
};

export default CommentHeaderInfo;
